/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from "react";
import { RulesContext } from "../RulesContext";
import { useHistory } from "react-router-dom";
import Bootbox from "../../../../Common/BootBoxManager";
import ServiceWrapper from "../../../../Services/ServiceWrapper";
import AuthManager from "../../../../Common/AuthManager";
import AppSettings from "../../../../Settings/AppSettings";
import Utils from "../../../../Common/Utils";
import GMSFillButton from "../../../Common/components/GMSFillButton";
import { toast } from "react-toastify";
import { AppContext } from "../../../../Context/AppContext";
import OverlayIcon from "./OverlayIcon";
import "../../Rules/Rules.css";
import ToggleButton from "Components/Common/components/Inputs/ToggleButton";
import { STATUS_LOOKUP, ASYMMETRIC, ASYMMETRIC_INSTRUCTIONS, CBA_INSTRUCTIONS, CBA_RULE, CBI_INSTRUCTIONS, CBI_RULE, CBM_INSTRUCTIONS, CBM_RULE, COMMITT_IN_PROGRESS_MESSAGE, RULE_DESCRIPTION, RULE_NAME, RULE_NAME_INSTRUCTIONS, RULE_TYPE, SELECT_RULE_TYPE, DECOMMITTED_MESSAGE, COMMITTED_MESSAGE, DECOMMITT_IN_PROGRESS_MESSAGE, CHANGE_RULE_WARNING } from "./RuleConstants";
import { LeftVectorIcon, LoadIcon } from "assests/GmsIcons";
import { RuleContext } from "Pages/GMS/Rules/contexts/RuleContext";
import Tooltip from "./Tooltip";
import ConfirmModal from "Pages/GMS/ISR/Components/RuleComponents/CommitConfirmModal";
import DecommitConfirmModal from "Pages/GMS/ISR/Components/RuleComponents/DecommitConfirmModal";
import _isEqual from "lodash/isEqual";
import { RULE_STAR } from "Pages/GMS/ISR/ISRConstants";
import ReloadButton from "Pages/GMS/ARS/Components/ReloadButton";

const RuleHeader = ({ ruleDetails, editPage, load_Rule_Details, loading, type, setRuleDetails, ruleHeaderDetails, setRuleHeaderDetails }) => {
  const history = useHistory();
  const api_base_url = AppSettings.GMS_BACKEND_API_URL;
  const appData = useContext(AppContext);
  const rulesContextData = useContext(RulesContext);
  const { setRuleType, ruleType, cellStates, selectedCategories, ruleState, setLoading, industryId, CBMOptions, setCbmRuleId, setCompatibilityData, ruleDispatch, initialRuleDetails, setInitialRuleDetails, setCBMOptions } = rulesContextData;
  const { leftCatListOption, rightCatListOption, leftValuesAttr, rightValuesAttr, defaultCompatibilityValue, compatibilityLevel, leftValuesAttrName, rightValuesAttrName, leftAttributeValueId, rightAttributeValueId, rightAttributeValueName, leftAttributeValueName, isProductFilter, } = CBMOptions;

  const [intialData, setIntialData] = useState(null);
  const [disableButton, setDisableButton] = useState({ commit: false, decommit: false, save: false, });
  const [edgeInfo, setEdgeInfo] = useState({ count: 0, status: "", message: "", });
  const [ruleStatus, setRuleStatus] = useState({ action: "", status: "", message: "", });

  const [showDecommitModal, setShowDecommitModal] = useState(false);
  const [showSaveModal, setShowSaveModal] = useState(false);

  useEffect(() => {
    const isValidMode = type === "edit" || type === "view";
    const hasRuleId = Boolean(ruleDetails?.id);

    if (isValidMode && hasRuleId) {
      getRuleStatus(true);
      getEdgeCount();
    }

    if (intialData === null) {
      setIntialData(ruleDetails);
    }
  }, [ruleDetails, type]);

  useEffect(() => {
    if (`${ruleStatus?.action}_${ruleStatus?.status}` !== "") {
      switch (
      STATUS_LOOKUP[`${ruleStatus?.action}_${ruleStatus?.status}`]?.message
      ) {
        case COMMITT_IN_PROGRESS_MESSAGE:
          setDisableButton({ commit: true, decommit: true, save: true });
          break;
        case DECOMMITT_IN_PROGRESS_MESSAGE:
          setDisableButton({ commit: true, decommit: true, save: true });
          break;
        case COMMITTED_MESSAGE:
          setDisableButton({ commit: true, decommit: false, save: true });
          break;
        case DECOMMITTED_MESSAGE:
          setDisableButton({ commit: !isRuleCommitable(), decommit: true, save: true });
          break;
        default:
          setDisableButton({ commit: false, decommit: false, save: false });
          break;
      }
    }
  }, [ruleStatus]);

  // Define these variables outside of any effect or function to make them accessible component-wide
  const isCBICBACommitable = () => {
    return !Utils.isEmpty(ruleHeaderDetails.name) &&
      !Utils.isEmpty(ruleHeaderDetails.rule_type) &&
      !Utils.isEmpty(selectedCategories.leftCategory.id) &&
      !Utils.isEmpty(selectedCategories.rightCategory.id) &&
      ruleState.rule.length > 0 &&
      !processRunning;
  };

  const isCBMCommitable = () => {
    // Check basic requirements
    if (Utils.isEmpty(ruleHeaderDetails.name) ||
      Utils.isEmpty(ruleHeaderDetails.rule_type) ||
      Utils.isEmpty(selectedCategories.leftCategory.id) ||
      Utils.isEmpty(selectedCategories.rightCategory.id) ||
      processRunning) {
      return false;
    }

    // Check for valid CBM attributes based on type
    if (!leftCatListOption || !rightCatListOption) {
      return false;
    }

    // For "products" type
    if (leftCatListOption === "products") {
      if (isProductFilter &&
        (!leftValuesAttr || !rightValuesAttr || !leftValuesAttrName || !rightValuesAttrName ||
          !leftAttributeValueId || !rightAttributeValueId ||
          !leftAttributeValueName || !rightAttributeValueName)) {
        return false;
      }
    }
    // For "values" type
    else if (leftCatListOption === "values") {
      if (!leftValuesAttr || !rightValuesAttr ||
        !leftValuesAttrName || !rightValuesAttrName) {
        return false;
      }
    }

    // Check if CBM has valid matrix rules
    return Object.values(cellStates).some(value => value !== 0);
  };


  const isRuleCommitable = () => {
    const { rule_type } = ruleHeaderDetails;

    if (rule_type === CBM_RULE) {
      return isCBMCommitable();
    } else if (rule_type === CBI_RULE || rule_type === CBA_RULE) {
      return isCBICBACommitable();
    }

    return false;
  };

  const [processRunning, setProcessRunning] = useState(false);
  const { setNewId } = useContext(RuleContext);
  const [commit, setCommit] = useState(false);

  useEffect(() => {
    if (ruleDetails) {
      const { name, rule_type, rule_status, description, commit, asymmetric } = ruleDetails;
      let asymmetric_val = typeof asymmetric === "boolean" ? asymmetric : false;

      setRuleHeaderDetails({
        ...ruleHeaderDetails,
        name,
        rule_type,
        rule_status,
        description,
        asymmetric: asymmetric_val,
      });
      setCommit(commit);
    }
    if (!processRunning) {
      setDisableButton({ decommit: false, commit: false, save: false });
    }
  }, [ruleDetails]);

  useEffect(() => {
    const { name, rule_type } = ruleHeaderDetails;
    const { leftCategory, rightCategory } = selectedCategories;

    // Helper function to check if CBM has valid matrix rules
    const hasCBMValidRules = () => {
      return Object.values(cellStates).some(value => value !== 0);
    };

    // Helper function to check if CBM attributes are properly set
    const isCBMAttributesValid = () => {
      // Common validation: left and right CatListOption must be set
      if (!leftCatListOption || !rightCatListOption) {
        return false;
      }

      // For "products" type
      if (leftCatListOption === "products") {
        // Basic validation for products
        if (!isProductFilter) return true;

        // If product filter is enabled, check additional fields
        if (!leftValuesAttr || !rightValuesAttr || !leftValuesAttrName || !rightValuesAttrName ||
          !leftAttributeValueId || !rightAttributeValueId ||
          !leftAttributeValueName || !rightAttributeValueName) {
          return false;
        }
      }
      // For "values" type
      else if (leftCatListOption === "values") {
        if (!leftValuesAttr || !rightValuesAttr ||
          !leftValuesAttrName || !rightValuesAttrName) {
          return false;
        }
      }

      return true;
    };

    // Helper function to check if CBI/CBA rules are valid
    const isCBICBAValid = () => {
      return !Utils.isEmpty(name) &&
        !Utils.isEmpty(rule_type) &&
        !Utils.isEmpty(leftCategory.id) &&
        !Utils.isEmpty(rightCategory.id) &&
        ruleState.rule.length > 0;
    };

    // For committed rules
    if (editPage && ruleDetails?.commit) {
      // For committed rule - Save always disabled, Decommit always enabled, Commit initially disabled
      setDisableButton({ commit: true, decommit: false, save: true });

      // For committed rule, enable Commit if changes detected AND the rule is valid
      const currentState = JSON.parse(JSON.stringify(composeRuleChanges()));
      if (hasStateChanged(initialRuleDetails, currentState)) {
        // Only enable Commit if the rule is valid
        if (rule_type === CBM_RULE) {
          // For CBM rules, validate CBM attributes and rules
          if (isCBMAttributesValid() && hasCBMValidRules()) {
            setDisableButton(prev => ({ ...prev, commit: false }));
          }
        } else if ((rule_type === CBI_RULE || rule_type === CBA_RULE) && isCBICBAValid()) {
          // For CBI/CBA rules, validate rule conditions
          setDisableButton(prev => ({ ...prev, commit: false }));
        }
      }
    }
    // For decommitted (existing) rules
    else if (editPage && !ruleDetails?.commit) {
      // For decommitted rule, Decommit always disabled
      setDisableButton({ commit: true, decommit: true, save: true });

      // Check if there are changes to the rule
      const currentState = JSON.parse(JSON.stringify(composeRuleChanges()));
      const hasChanges = hasStateChanged(initialRuleDetails, currentState);

      // For decommitted rule, check if Save should be enabled after user made changes
      if (!processRunning && hasChanges) {
        // For CBI/CBA rules
        if ((rule_type === CBI_RULE || rule_type === CBA_RULE) && isCBICBAValid()) {
          setDisableButton(prev => ({ ...prev, save: false }));
        }
        // For CBM rules
        else if (rule_type === CBM_RULE && isCBMAttributesValid()) {
          setDisableButton(prev => ({ ...prev, save: false }));
        }
      }

      // For decommitted rule, check if Commit should be enabled
      if (!processRunning) {
        // For CBI/CBA rules
        if ((rule_type === CBI_RULE || rule_type === CBA_RULE) && isCBICBAValid()) {
          setDisableButton(prev => ({ ...prev, commit: false }));
        }
        // For CBM rules
        else if (rule_type === CBM_RULE && isCBMAttributesValid() && hasCBMValidRules()) {
          setDisableButton(prev => ({ ...prev, commit: false }));
        }
      }
    }
    // For new rules (not edit page)
    else if (!editPage) {
      // Reset buttons for new rule
      setDisableButton({ commit: true, decommit: true, save: true });

      // Conditions to enable Save for new rule
      if (!processRunning) {
        // For CBI/CBA rules
        if ((rule_type === CBI_RULE || rule_type === CBA_RULE) && isCBICBAValid()) {
          setDisableButton(prev => ({ ...prev, save: false }));
        }
        // For CBM rules
        else if (rule_type === CBM_RULE && !Utils.isEmpty(name) &&
          !Utils.isEmpty(leftCategory.id) && !Utils.isEmpty(rightCategory.id) &&
          isCBMAttributesValid()) {
          setDisableButton(prev => ({ ...prev, save: false }));
        }
      }
    }

    setRuleType(rule_type);
  }, [ruleHeaderDetails, rulesContextData, selectedCategories, ruleState, cellStates]);
  function handle_change(id, value) {

    if (id === "rule_type") {
      setCompatibilityData([]);
      ruleDispatch({ type: "CBM_RULE_TYPE", data: [] });
      setCBMOptions({ leftCatListOption: "", rightCatListOption: "", leftCatAttributeSet: [], rightCatAttributeSet: [], leftCatProductList: [], rightCatProductList: [], leftAttributeValues: [], rightAttributeValues: [], leftValuesAttr: "", leftValuesAttrName: "", rightValuesAttr: "", rightValuesAttrName: "", leftAttributeValueName: '', leftAttributeValueId: '', rightAttributeValueName: '', rightAttributeValueId: '', defaultCompatibilityValue: "", compatibilityLevel: "level4", showWarningModal: false, editMode: false, toggleSelectInput: false, showWarninModal: false, leftCatID: "", rightCatID: "", selectedCell: {}, valueToBeSaved: "", isProductFilter: false });
      setRuleDetails((prev) => {
        return {
          ...prev,
          ...ruleHeaderDetails,
          rule_body: {},
          rule_type: value,
        };
      });
    } else {
      setRuleHeaderDetails((prevState) => {
        return { ...prevState, [id]: value };
      });
    }
  }

  function hasStateChanged(initialState, changeState) {
    const keysToCheck = [
      "name",
      "rule_type",
      "description",
      "asymmetric",
      "left_category",
      "right_category",
    ];

    if (initialState && changeState) {
      for (const key of keysToCheck) {
        if (!_isEqual(initialState[key], changeState[key])) {
          return true;
        }
      }

      if (initialState.rule_type === "CBM" && changeState.rule_type === "CBM") {
        const initialCellStates = initialState.rule_body?.cellStates || {};
        const changeCellStates = changeState.rule_body?.cellStates || {};

        const initialEntries = Object.entries(initialCellStates)
          .filter(([_, value]) => value !== 0);
        const changeEntries = Object.entries(changeCellStates)
          .filter(([_, value]) => value !== 0);

        if (!_isEqual(initialEntries, changeEntries)) {
          return true;
        }

        const cbmPropsToCheck = [
          "defaultCompatibilityValue",
          "compatibilityLevel",
          "leftCatCompatibilityType",
          "rightCatCompatibilityType",
          "isProductFilter"
        ];

        for (const prop of cbmPropsToCheck) {
          if (!_isEqual(initialState.rule_body?.[prop], changeState.rule_body?.[prop])) {
            return true;
          }
        }

        if (changeState.rule_body?.isProductFilter) {
          const productPropsToCheck = [
            "leftAttributeId",
            "rightAttributeId",
            "leftValuesAttrName",
            "rightValuesAttrName",
            "leftAttributeValueId",
            "rightAttributeValueId",
            "leftAttributeValueName",
            "rightAttributeValueName"
          ];

          for (const prop of productPropsToCheck) {
            if (!_isEqual(initialState.rule_body?.[prop], changeState.rule_body?.[prop])) {
              return true;
            }
          }
        }

        return false;
      }
      else if (!_isEqual(initialState.rule_body, changeState.rule_body)) {
        return true;
      }
    }
    return false;
  }

  const handleCommit = async () => {
    try {
      setEdgeInfo({ status: "Loading", message: "Loading", count: null });
      saveRule(false).then(async (success) => {
        if (success) {
          setRuleStatus({ action: "Commit", status: "In Progress" });
          setDisableButton({ save: true, commit: true, decommit: true });
          setProcessRunning(true);
          setLoading({ status: "Saving", message: "Committing rule" });
          const res = await ServiceWrapper.doPost(
            `${api_base_url}rule/publish/${ruleDetails.id}`,
            null,
            null,
            AuthManager.getGmsToken()
          );
          if (!res.errorfound) {
            setDisableButton({ save: false, commit: true, decommit: false });
            setLoading({ status: "Success", message: "Saved" });
            if (res?.data?.done) {
              toast.success(
                <div className="tw-w-full">
                  <span className="tw-text-black tw-text-sm tw-font-semibold tw-leading-tight">
                    Committing in progress
                  </span>
                </div>,
                {
                  style: {
                    backgroundColor: "#e3fcef",
                  },
                }
              );
              setEdgeInfo({ status: "", message: undefined, count: "0" });
              setTimeout(() => {
                getRuleStatus();
                getEdgeCount();
                load_Rule_Details(ruleDetails.id);
              }, 2000);
            } else {
              toast.error("Error occurred while adding rule to queue.");
              setEdgeInfo({ status: "", message: undefined, count: "0" });
            }
          } else {
            setDisableButton({ save: false, commit: false, decommit: true });
            setProcessRunning(false);
            toast.error("Error while committing rule");
            setLoading({
              status: "Error",
              message: "Error while commiting Rules",
            });
          }
        }
      });
      setTimeout(() => {
        history.push("/gms/rules/list");
      }, 3000);
    } catch (error) {
      console.log("consthandle_commit= ~ error:", error);
    }
  };

  const onHandleDecommit = () => {
    setShowDecommitModal(true);
  };

  const onDecommitConfirm = () => {
    setShowDecommitModal(false);
    handleDecommit();
  };

  const onBackButtonClicked = () => {
    if (!isViewMode && !ruleDetails?.commit) {
      if (hasStateChanged(initialRuleDetails, composeRuleChanges()))
        return setShowSaveModal(true);
    }
    return history.push("/gms/rules/list");
  };

  const onSaveConfirm = async () => {
    setShowSaveModal(false);
    await saveRule(false);
    setTimeout(() => {
      history.push("/gms/rules/list");
    }, 3000);
  };

  const handleDecommit = async () => {
    try {
      setEdgeInfo({ status: "Loading", message: "Loading", count: null });
      saveRule(false).then(async (success) => {
        if (success) {
          setRuleStatus({ action: "Decommit", status: "In Progress" });
          setDisableButton({ save: true, commit: true, decommit: true });
          setProcessRunning(true);
          setLoading({ status: "Saving", message: "Decommiting rule" });
          const res = await ServiceWrapper.doPost(
            `${api_base_url}rule/decommit/${ruleDetails.id}`,
            null,
            null,
            AuthManager.getGmsToken()
          );
          if (res.errorfound) {
            toast.error("Error while decommiting rule");
            updateHeader();
            setEdgeInfo({ status: "Success", message: undefined, count: "0" });
            setDisableButton({ save: false, commit: true, decommit: false });
            return;
          }
          if (res?.data?.done) {
            toast.success(
              <div className="tw-w-full">
                <span className="tw-text-black tw-text-sm tw-font-semibold tw-leading-tight">
                  Decommitting in progress
                </span>
              </div>,
              {
                style: {
                  backgroundColor: "#e3fcef",
                },
              }
            );
            history.push({
              pathname: `/gms/rules/list`,
            });
          } else {
            toast.error("Error occurred while adding rule to queue.");
          }
          setLoading({ status: "Success", message: "Saved" });
          setEdgeInfo({ status: "", message: undefined, count: "0" });
          updateHeader();
          load_Rule_Details(ruleDetails.id);
        }
      });
    } catch (error) {
      console.log("consthandle_decommit= ~ error:", error);
    }
  };

  useEffect(() => {
    updateHeader();
  }, [ruleDetails?.id]);

  const updateHeader = () => {
    setProcessRunning(false);
  };

  const checkDownloadStatus = async (jobid) => {
    try {
      const statusResponse = await ServiceWrapper.doGet(
        `${api_base_url}job/status/${jobid}`,
        null,
        null,
        AuthManager.getGmsToken()
      );

      if (!statusResponse.errorfound) {
        const { data } = statusResponse;

        if (data?.error) {
          setEdgeInfo({ status: "", message: "", count: null });
          return;
        }

        if (data?.processing) {
          setTimeout(() => {
            checkDownloadStatus(jobid);
          }, 2000);
          setEdgeInfo({
            status: "Loading",
            message: statusResponse?.data?.message,
            count: null,
          });
          return;
        }
        setProcessRunning(false);
        const edgeCount = data.data;
        setEdgeInfo({
          status: "Success",
          message: "Completed",
          count: edgeCount,
        });
      }
    } catch (error) {
      console.error("Error occurred while checking download status:", error);
    }
  };

  const getRuleStatus = async (firstLoad = false) => {
    try {
      const ret = await ServiceWrapper.doGet(
        `${api_base_url}rule/status/${ruleDetails?.id}`,
        null,
        null,
        AuthManager.getGmsToken()
      );
      if (!ret.errorfound) {
        setRuleStatus(ret?.data?.rule_status);
        if (ret?.data?.rule_status?.status === "Failed") {
          !firstLoad &&
            toast.error(
              `${ret?.data?.rule_status?.action} ${ret?.data?.rule_status?.status} retry again`
            );
          if (ret?.data?.rule_status?.action === "Commit") {
            setDisableButton({ decommit: true, commit: false, save: true });
          } else
            setDisableButton({ decommit: false, commit: true, save: true });
        }
      } else {
        toast.error("Error while fetching rule status");
      }
    } catch (error) {
      console.log("getRuleStatus ~ error:", error);
    }
  };

  const getEdgeCount = async () => {
    try {
      setEdgeInfo({
        ...edgeInfo,
        status: "Loading",
        message: "Preparing edge count request...",
      });

      const ret = await ServiceWrapper.doGet(
        `${api_base_url}rule/edge-count/${ruleDetails?.id}`,
        null,
        null,
        AuthManager.getGmsToken()
      );
      if (!ret.errorfound) {
        setTimeout(() => {
          checkDownloadStatus(ret.data.jobid);
        }, 2000);
      } else {
        toast.error("Error while fetching Edge count");
        setEdgeInfo({
          status: "Error",
          message: "Error while fetching Edge count",
        });
      }
    } catch (error) {
      console.log("getEdgeCount ~ error:", error);
    }
  };

  const composeRuleChanges = (json_string = false) => {
    let finalRule;
    if (ruleType === CBM_RULE) {
      finalRule = {
        ...ruleHeaderDetails,
        left_category: selectedCategories.leftCategory.id,
        right_category: selectedCategories.rightCategory.id,
        commit: commit,
        industry_id: industryId,
        rule_body: {
          defaultCompatibilityValue: defaultCompatibilityValue,
          compatibilityLevel: compatibilityLevel,
          leftCatCompatibilityType: leftCatListOption,
          rightCatCompatibilityType: rightCatListOption,
          leftCatID: selectedCategories.leftCategory.id,
          rightCatID: selectedCategories.rightCategory.id,
          cellStates: cellStates,
          leftAttributeId: leftValuesAttr,
          leftValuesAttrName: leftValuesAttrName,
          rightAttributeId: rightValuesAttr,
          isProductFilter: isProductFilter,
          rightValuesAttrName: rightValuesAttrName,
          ...(leftCatListOption === "products" && {
            leftAttributeValueId: leftAttributeValueId,
            leftAttributeValueName: leftAttributeValueName,
            rightAttributeValueId: rightAttributeValueId,
            rightAttributeValueName: rightAttributeValueName,
          }),
          rule: {
            rule: ruleState.rule,
          },
        },
      };
    } else {
      finalRule = {
        ...ruleHeaderDetails,
        industry_id: industryId,
        left_category: selectedCategories.leftCategory.id,
        right_category: selectedCategories.rightCategory.id,
        commit: commit,
        rule_body: {
          leftCatID: selectedCategories.leftCategory.id,
          rightCatID: selectedCategories.rightCategory.id,
          rule: {
            rule: ruleState.rule,
          },
        },
      };
    }
    if (json_string) finalRule.rule_body = JSON.stringify(finalRule?.rule_body);
    return finalRule;
  };

  const saveRule = async ({ reload = true }) => {
    try {
      setDisableButton({ decommit: true, commit: true, save: true });
      setProcessRunning(true);
      let finalRule = composeRuleChanges(true);
      setLoading({ status: "Saving", message: "Saving Rules details" });
      let url;
      let res;
      if (editPage) {
        url = `${api_base_url}rule/edit/${ruleDetails.id}`;
        res = await ServiceWrapper.doPut(
          url,
          finalRule,
          null,
          AuthManager.getGmsToken()
        );
      } else {
        url = `${api_base_url}rule/create`;
        res = await ServiceWrapper.doPost(
          url,
          finalRule,
          null,
          AuthManager.getGmsToken()
        );
      }
      setProcessRunning(false);

      if (res.data.done) {
        if (!editPage) {
          toast.success("Saved successfully");
          setNewId(res?.data?.id);
          history.replace({
            pathname: `/gms/rule/edit/${res?.data?.id ?? "0"}`,
          });
        } else {
          toast.success("Updated successfully");
          load_Rule_Details(res?.data?.id);
          setDisableButton(prev => ({ ...prev, save: true }));
        }
        setLoading({ status: "Success", message: res.data.message });
        setCbmRuleId(res.data.id);
        return true;
      } else {
        toast.error(res.data.message);
        return false;
      }
    } catch (error) {
      console.log("Save_Rule_Details ~ error:", error);
    }
  };

  const handleOnRuleTypeChange = (e) => {
    if (ruleState && ruleState.rule.length !== 0) {
      Bootbox.confirm(
        "Change Rule Type?",
        CHANGE_RULE_WARNING,
        false,
        [handle_change, e.target.id, e.target.value]
      );
    } else {
      handle_change(e.target.id, e.target.value);
    }
  };

  const handleOnAsymmetricChange = (e) => {
    if (e.target.checked) {
      setRuleHeaderDetails((prevState) => {
        return { ...prevState, asymmetric: true };
      });
    } else {
      setRuleHeaderDetails((prevState) => {
        return { ...prevState, asymmetric: false };
      });
    }
  };

  const statusChip = () => {
    const color =
      STATUS_LOOKUP[`${ruleStatus?.action}_${ruleStatus?.status}`]?.bgColor;
    const textColor =
      STATUS_LOOKUP[`${ruleStatus?.action}_${ruleStatus?.status}`]?.textColor;
    const message =
      STATUS_LOOKUP[`${ruleStatus?.action}_${ruleStatus?.status}`]?.message;
    const loader =
      STATUS_LOOKUP[`${ruleStatus?.action}_${ruleStatus?.status}`]?.loader;
    return (
      <div
        className={`tw-h-8 tw-w-[120%] tw-px-[4px] tw-py-2 tw-rounded tw-justify-center tw-items-center tw-gap-2.5 tw-inline-flex`}
        style={{ backgroundColor: color }}
      >
        <div
          className={`tw-text-center  tw-text-sm`}
          style={{ color: textColor }}
        >
          {message}
        </div>
        {loader ? <LoadIcon /> : null}
      </div>
    );
  };

  const isViewMode = type === "view";

  return (
    <>
      <div className="tw-flex tw-items-center tw-justify-between tw-border-b tw-mb-4">
        <div className="tw-flex tw-items-center tw-gap-3 tw-pb-2">
          <button onClick={onBackButtonClicked} className="tw-float-left tw-w-[4%]">
            <LeftVectorIcon />
          </button>
          {ruleHeaderDetails?.name !== "" ? (
            <div className="tw-w-32 tw-overflow-hidden">
              <Tooltip text={ruleHeaderDetails?.name}>
                <label className="tw-font-semibold tw-text-xl tw-text-[#091E42] tw-truncate tw-block">
                  {ruleHeaderDetails?.name}
                </label>
              </Tooltip>
            </div>
          ) : (
            <label className="tw-font-semibold tw-text-xl tw-text-[#091E42] tw-truncate tw-block">
              Compatibility
            </label>
          )}
          {editPage ? <div>{statusChip()}</div> : null}
        </div>

        <div
          className="tw-flex tw-items-center tw-justify-end tw-gap-3 tw-pb-2"
          style={
            isViewMode
              ? {
                pointerEvents: "none",
                opacity: 0.6,
                userSelect: "none",
              }
              : {}
          }
        >
          {editPage ? (
            <>
              <div className="tw-h-8 tw-px-[22px] tw-py-2 tw-bg-[#dde0fc] tw-rounded tw-justify-center tw-items-center tw-gap-2.5 tw-inline-flex">
                <div className="tw-text-center tw-text-[#172b4d] tw-text-sm  tw-leading-tight">
                  Edge Count
                </div>
                <div className="tw-text-center tw-text-[#172b4d] tw-text-sm tw-font-medium tw-leading-tight">
                  {edgeInfo?.count}
                </div>
              </div>
              <ReloadButton
                loading={edgeInfo.status === "Loading"}
                onClick={() => {
                  getRuleStatus();
                  getEdgeCount();
                }}
              />
            </>
          ) : null}
          <>
            {editPage ? (
              <button
                type="button"
                className="button-outlined"
                disabled={disableButton.decommit}
                style={{
                  marginRight: "6px",
                }}
                onClick={() => {
                  if (appData.pm.checkPermission("gmsrules_update")) {
                    onHandleDecommit();
                  } else {
                    toast.info(
                      "You don't have permission to decommit the rules"
                    );
                  }
                }}
              >
                Decommit
              </button>
            ) : (
              <button
                type="button"
                className="button-outlined"
                style={{
                  marginRight: "6px",
                }}
                onClick={() => {
                  history.push({
                    pathname: `/gms/rules/list`,
                  });
                }}
              >
                Cancel
              </button>
            )}
            {(type === 'copy' ? true : !ruleDetails?.commit) && <GMSFillButton
              name="Save"
              onClick={() => {
                if (appData.pm.checkPermission("gmsrules_update")) {
                  saveRule(true);
                } else {
                  toast.info("You don't have permission to save the rules");
                }
              }}
              disabled={disableButton.save}
            />}
            {editPage && <GMSFillButton
              name="Commit"
              disabled={disableButton?.commit}
              onClick={() => {
                if (appData.pm.checkPermission("gmsrules_update")) {
                  handleCommit();
                } else {
                  toast.info("You don't have permission to commit the rules");
                }
              }}
            />}
          </>
        </div>
      </div>
      <div
        style={
          isViewMode
            ? {
              pointerEvents: "none",
              opacity: 0.6,
              userSelect: "none",
            }
            : {}
        }
      >
        <div className="tw-flex tw-items-center tw-gap-3">
          <div className="tw-w-[30%]">
            <div className="tw-flex tw-gap-1 tw-items-center">
              <label className="text-caption-style tw-text-[#747593]">
                {RULE_NAME}
              </label>
              <OverlayIcon placement="right" message={RULE_NAME_INSTRUCTIONS} />
              <span className="tw-text-red-500 ">{RULE_STAR}</span>
            </div>
            <input
              type="text"
              className="shadow-none drop-down-dm tw-ps-2"
              id="name"
              value={ruleHeaderDetails.name}
              placeholder="Rule Name"
              aria-describedby="nameHelp"
              maxLength="60"
              minLength="2"
              onChange={(e) => handle_change(e.target.id, e.target.value)}
            />
          </div>
          <div className="tw-w-[20%]">
            <div className="tw-flex tw-items-center tw-gap-1">
              <label className="text-caption-style tw-text-[#747593]">
                {RULE_TYPE}
              </label>
              <OverlayIcon
                placement="right"
                message={
                  <>
                    <p>{CBA_INSTRUCTIONS}</p>
                    <p>{CBI_INSTRUCTIONS}</p>
                    <p>{CBM_INSTRUCTIONS}</p>
                  </>
                }
              />
            </div>
            <select
              className="shadow-none form-select drop-down-dm tw-ps-3"
              title={ruleHeaderDetails.rule_type}
              id="rule_type"
              aria-label={RULE_TYPE}
              value={ruleHeaderDetails.rule_type}
              disabled={type === 'copy' ? false : ruleDetails?.commit}
              onChange={(e) => handleOnRuleTypeChange(e)}
            >
              <option value="">{SELECT_RULE_TYPE}</option>
              <option value={CBI_RULE}>{CBI_RULE}</option>
              <option value={CBA_RULE}>{CBA_RULE}</option>
              <option value={CBM_RULE}>{CBM_RULE}</option>
            </select>
          </div>
          <div className="tw-w-[10%]">
            <div className="tw-flex tw-gap-1 tw-items-center">
              <label className="pb-1 text-caption-style tw-text-[#747593]">
                {ASYMMETRIC}
              </label>
              <OverlayIcon placement="left" message={ASYMMETRIC_INSTRUCTIONS} />
            </div>
            <ToggleButton
              name="Asymmetric Rule"
              value={ruleHeaderDetails.asymmetric}
              onChange={(e) => handleOnAsymmetricChange(e)}
            />
          </div>
        </div>
        <div className="tw-mt-4 tw-flex tw-items-center tw-gap-4 tw-mb-4">
          <div className="tw-w-[51%]">
            <label className="text-caption-style tw-text-[#747593]">
              {RULE_DESCRIPTION}
            </label>
            <textarea
              type="text"
              className="drop-down-dm tw-shadow-none"
              id="description"
              placeholder={RULE_DESCRIPTION}
              value={ruleHeaderDetails.description}
              onChange={(e) => handle_change(e.target.id, e.target.value)}
            />
          </div>
        </div>
        {showDecommitModal ? (
          <DecommitConfirmModal
            title="Decommit"
            message="you will lose all data here"
            onClose={() => setShowDecommitModal(false)}
            onConfirm={onDecommitConfirm}
            ternaryMethod={onDecommitConfirm}
            ternaryText="text"
            confirmText="Decommit"
            cancelText="Cancel"
          />
        ) : null}
        {showSaveModal ? (
          <ConfirmModal
            title="Unsaved Changes"
            message="You have unsaved changes to this rule. What would you like to do?"
            onClose={() => setShowSaveModal(false)}
            onConfirm={onSaveConfirm}
            ternaryMethod={() => {
              history.push("/gms/rules/list");
            }}
            ternaryText="Discard changes"
            confirmText="Save Changes"
            cancelText="Cancel"
          />
        ) : null}
      </div>
    </>
  );
};
export default RuleHeader;